<template>
  <div>
    
    <b-container>
      <div class="whitespace" style="height:50px;"></div>
      <b-row>
        <b-col>
          <router-link to="/">
          <img style='margin-bottom:20px;' src="@/assets/logo.svg" alt />
          </router-link>
          <h3>
            Введите Ваш новый пароль. Помните, что он должен состоять минимум из 8 символов и содержать хотя бы одну букву
          </h3>
        </b-col>
      </b-row>
      <b-row style="margin-top:15px;">
        <b-col sm="10">
          <div class="name" >
            <transition name="fade">
              <b-form-input type="password" v-model="form.recover" placeholder="Новый пароль"></b-form-input>
            </transition>
            <transition name="fade">
              <b-form-input type="password" v-model="form.recover2" placeholder="Повторите пароль" v-if="form.recover"></b-form-input>
            </transition>
            <transition name="fade" v-if="form.recover && form.recover2">
             <b-button @click="onSubmit" variant="primary" block style="margin-bottom: 30px; color:white">Готово</b-button>
            </transition>
          </div>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>

import Story from "@/components/Story.vue";
import API from "@/api";
export default {
  name: "MakeUser",
  components: {
    Story
  },
  data() {
    return {
      selected: false,
      form: {
        recover: '', 
        recover2: ''
      }
    };
  },
  mounted() {
     this.$loading.hide()
  },
  methods: {
     
    onSubmit() {
      if(this.form.recover != this.form.recover2)
      {
        this.$bvToast.toast('Проверьте и попробуйте еще раз', {
          title: 'Пароль не совпадают',
          variant: 'danger',
          solid: true
        })
        return
      }
      if(this.form.recover.length < 8)
      {
        this.$bvToast.toast('пароль должен состоять минимум из 8 символов', {
          title: 'Слишком короткий пароль',
          variant: 'danger',
          solid: true
        })
        return
      }

      const data = new FormData();
      data.append("s", this.$route.query.s);
      data.append("password", this.form.recover);
      API.post("api/change_password", data).then(
        response => {
          this.$router.push({ path: '/?recover=true' })
        }
      )
      .catch(e =>{
          if(e.response.status = 400)
          {
          this.$bvToast.toast('Создайте другой пароль', {
            title: e.response.data.errors[0],
            variant: 'danger',
            solid: true
          })
          }
        });
    }
  }
};
</script>

<style scoped>
.toggle-switch label
{
  line-height: 1.4 !important;
}
.person_icon
{
  width:90px;
  margin-bottom: 10px;
  cursor: pointer;
  
}
.big.person_icon
{
  width:130px ;
  
}
.card {
  margin: auto;
  margin-top: 5em;
  box-shadow: 1.5px 1px 10px rgba(228, 229, 247, 0.5);
}
.alert {
  margin-top: 1em;
  margin-left: 5em;
  margin-right: 5em;
  max-width: 40rem;
}
.image {
  background-color: rgb(255, 255, 255);
  border: none;
  border-radius: 50%;
}
.but {
  margin-top: 10px;
  background-color: none;
  color: none;
  border: none;
}

.welcome {
  font-family: "Roboto", sans-serif;
  font-style: bold;
  font-weight: 500;
  font-size: 33px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.name input {
  margin-bottom: 10px;
}
</style>